import styled from 'styled-components';

export const StyledPlatformsLinkWithLocation = styled.div`
    padding: 2rem;
`;
